<template>
    <app-base-main parentTable>
      <template #filter-group>
        <app-filter-group
            @query="$gjNoticeQuery"
            @reset="$gjReset">
          <app-filter-item>
            <gj-select-input
                v-model="filter.code"
                :options="option.code"
                :width="['100px', '120px']"
            ></gj-select-input>
          </app-filter-item>
          <app-filter-item>
            <gj-select
                v-model="filter.statusList"
                :options="option.status"
                multiple
                collapse-tags
                placeholder="状态"
                width="145px"
            ></gj-select>
          </app-filter-item>
          <app-filter-item>
            <gj-supplier-select
                v-model="filter.supplier"
                placeholder="供应商"
            ></gj-supplier-select>
          </app-filter-item>
          <app-filter-item>
            <gj-warehouse-select
                v-model="filter.deliveryWarehouseId"
                :fba="false"
                placeholder="入库仓"
                width="150px"
            ></gj-warehouse-select>
          </app-filter-item>
          <app-filter-item>
            <gj-select-input
                v-model="filter.keyword"
                :options="option.keyword"
                :width="['100px', '120px']"
            ></gj-select-input>
          </app-filter-item>
          <app-filter-item priority="1">
            <gj-creator-select
                v-model="filter.createUser"
                placeholder="创建人"
                width="120px"
            ></gj-creator-select>
          </app-filter-item>
          <app-filter-item priority="2">
            <gj-select-date-picker
                v-model="filter.date"
                :options="option.date"
                type="daterange"
            ></gj-select-date-picker>
          </app-filter-item>

          <template #right>
            <view-setting
                    :ref="REF_VIEW_SETTING"
                    save-mode="remote"
                    :use-default="true"
                    :module-name="moduleName"
                    :config="model"
                    :fn-generate-params="generateViewParams"
                    @view-change="handleChangeView"
                    @view-complete="handCompleteView"

            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button
            v-if="$permission('purchaseInbound:inbound')"
            type="primary"
            :disabled="noSelect || selectedSomeNotIn('status', [StatusEnum.WAIT_INBOUND, StatusEnum.IN_INBOUND])"
            @click="inbound(selectedRows)">
          登记入库
        </gj-button>
      </template>
      <template #tool-group>
        <gj-tool-group
            :download="false" download-url="" :download-params="globalParams"
            help
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :name="tableName"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            selection
            :scroll-x="{gt: -1}"
            :scroll-y="{gt: -1}"
            :bak-selected-rows="bakSelectedRows"
            :bak-rows="selectedRows"
            @clearBakSelectedRows="clearBakRows"
            :selectable="(row) => row.$gjParentData  && !row.$gjExtendRow"
            :extend-row-config="{prop: 'extendRow'}"
            :structure-config="{type: 'ParentChild', children: 'items', parentSpan: [1, 8]}"
            sortable="custom"
            :pagination="pagination"
            :show-overflow="false"
            :default-sort="{prop: 'createTime', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:purchaseOrder="{row}">
            <template v-if="row.$gjParentData">
              <div class="purchaseOrder-content">
                <span>{{row.deliveryNoteCode | defaultShow}}</span>
                <gj-copy-icon :content="row.deliveryNoteCode" />
              </div>
              <div v-gutter="20" style="display: inline-block;">
                <span>{{row.deliveryWarehouseName | defaultShow}}</span>
                <gj-tag
                    type="plain"
                    shape="rectangle"
                    :color="row.status | optionColor(InboundOrderEnum.statusOption)">
                  {{ row.status | optionText(InboundOrderEnum.statusOption) }}
                </gj-tag>
                <gj-text max-width="100px">{{row.supplierName | defaultShow}}</gj-text>
                <gj-tag
                    type="dark"
                    shape="rectangle"
                    :color="row.settlementWay | optionColor(PurchaseOrderEnum.settleOption)">
                  {{ row.settlementWay | optionText(PurchaseOrderEnum.settleOption) }}
                </gj-tag>
                <span><span style="color: #999999">总金额：</span>{{row.totalAmount | amount | defaultShow(row.currencySymbol)}}</span>
                <span><span style="color: #999999">创建人：</span>{{row.createUserName | defaultShow}}</span>
                <span><span style="color: #999999">创建时间：</span>{{row.createTime | defaultShow}}</span>
                <span><span style="color: #999999">入库量/良品量/次品量：</span>{{row.totalInboundQuantity || 0}} / {{row.totalInboundGoodQuantity || 0}} / {{row.totalInboundBadQuantity || 0}}</span>
              </div>
            </template>
            <template v-else>
              <div class="purchaseOrder-content">
                <span>{{row.purchaseOrderCode | defaultShow}}</span>
                <gj-copy-icon :content="row.purchaseOrderCode" />
              </div>
            </template>
          </template>
          <template v-slot:sku="{row}">
            <div>
              <gj-text>{{row.productName | defaultShow}}</gj-text>
            </div>
            <div>{{row.sku | defaultShow}}</div>
            <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
          </template>
          <template v-slot:op="{ row }">
            <template v-if="row.$gjParentData">
              <gj-button-group
                  type="dropdown-op"
                  :config="opBtnConfig(row)"
              ></gj-button-group>
            </template>
          </template>
          <template v-slot:extend:row="{row}">
            <div class="default">
              <div v-if="!row.expand">
                <gj-link type="default" @click="openDetail(row,true)">
                  更多（共{{row.num}}条）
                  <i class="iconfont iconzhankai"></i>
                </gj-link>
              </div>
              <div v-else>
                <gj-link type="default" @click="openDetail(row, false)">
                  收起
                  <i class="iconfont iconshouqi"></i>
                </gj-link>
              </div>
            </div>
          </template>
        </gj-table>
      </template>
    </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin, selectionMixin, valueCheckMixin, bakSelectRowsMixin} from "@/minxins";
  import {InboundOrderEnum} from "./enum";
  import {getInboundOrderPage} from "@/api/warehouse";
  import AppInboundProductModal from "./modal/inbound/inbound-product-modal";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import {PurchaseOrderEnum} from "../../purchase/purchase-order/enum";
  import {ProductEnum} from "@/utils/options";
  import {defaultVal} from "@/utils/common";
  import model from './viewConfig'

  const StatusEnum = InboundOrderEnum.status;

  export default {
    name: "app-inbound-order",
    mixins: [queryMixin, selectionMixin, responseMixin, valueCheckMixin, bakSelectRowsMixin],
    data() {
      return {
        tableName: 'inboundOrder',
        tableData: [],
        columns: [
          {id: 'purchaseOrder', header: '采购单号', field: 'slot:purchaseOrder', width: '150px'},
          {id: 'picture', header: '图片', field: 'picture:skuImageUrl', width: '50px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '300px'},
          {id: 'deliveryQuantity', header: '交货量', field: 'deliveryQuantity', width: '120px', align: 'right'},
          {id: 'inboundGoodQuantity', header: '入库良品量', field: 'inboundGoodQuantity', width: '120px', align: 'right'},
          {id: 'inboundBadQuantity', header: '入库次品量', field: 'inboundBadQuantity', width: '120px', align: 'right'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', prefix: 'currencySymbol', width: '120px', align: 'right'},
          {id: 'purchaseNum', header: '入库金额', field: 'inboundAmount', prefix: 'currencySymbol', amount: true, width: '120px', align: 'right'},
          {id: 'op', header: '操作', field: 'slot:op', width: '130px', fixed: 'right'},
        ],
        opBtnConfig: (row) => [
          {
            label: '登记入库',
            show: () => this.$permission('purchaseInbound:inbound')
              && (row.status === StatusEnum.WAIT_INBOUND || row.status === StatusEnum.IN_INBOUND),
            click: () => this.inbound([{...row, items: row.productsCopy}])
          },
          {
            label: '日志',
            click: () => this.viewLog({...row, items: row.productsCopy})
          },
        ],
        filter: {
          code: {
            key: 'purchaseOrderCode',
            value: null
          },
          statusList: [],
          countryMarket: null,
          supplier: null,
          deliveryWarehouseId: null,
          keyword: {
            key: 'sku',
            value: null
          },
          createUser: null,
          date: {
            key: 'createDate',
            value: null
          }
        },
        option: {
          code: [
            {id: 'purchaseOrderCode', text: '采购单号'},
            {id: 'deliveryNoteCode', text: '交货单号'},
          ],
          status: InboundOrderEnum.statusOption,
          keyword: [
            {id: 'sku', text: 'SKU'},
            {id: 'productName', text: '产品名称'},
          ],
          date: [
            {id: 'createDate', text: '创建时间'}
          ]
        },
        InboundOrderEnum: InboundOrderEnum,
        StatusEnum: StatusEnum,
        PurchaseOrderEnum: PurchaseOrderEnum,
        productTypeOption: ProductEnum.typeOption,
        moduleName: 'INBOUND_ORDER',
        model
      }
    },
    created() {
      this.sort.prop = 'createTime';
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : { key: params.dateType, value: [params.startDateTime, params.endDateTime]}
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      loadViewComplete () {
        this.$emit('query')
      },
      $gjQueryInitParams() {
        return {
          filter: {
            code: {
              key: 'purchaseOrderCode',
              value: null
            },
            statusList: [],
            countryMarket: null,
            supplier: null,
            deliveryWarehouseId: null,
            keyword: {
              key: 'sku',
              value: null
            },
            createUser: null,
            date: {
              key: 'createDate',
              value: null
            }
          },
        };
      },
      $gjQuery() {
        // 构造查询参数
        const date = this.filter.date.value;
        const params = {
          model: {
            [this.filter.code.key]: this.filter.code.value,
            statusList: this._.isEmpty(this.filter.statusList) ? null : this.filter.statusList,
            supplierCode: defaultVal(this.filter.supplier),
            deliveryWarehouseId: defaultVal(this.filter.deliveryWarehouseId),
            [this.filter.keyword.key]: this.filter.keyword.value,
            createUser: defaultVal(this.filter.createUser),
            startCreateTime: date ? convertToDate(date[0]) : null,
            endCreateTime: date ? convertToDate(date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getInboundOrderPage(params)
          .then(data => {
            this.tableData = data.records.map((v, i) => {
              const items = this._.cloneDeep(v.items)
              return Object.assign(v, {
                productsCopy: items,
                items: items ? items.slice(0, 3) : [],
                expand: false,
                dataIndex: i
              })
            });
            this.pagination = this.getPagination(data);
          })
          .complete(() => {
            this.loading = false;
          });
      },
      inbound(rows) {
        this.$gjCreate(AppInboundProductModal, {
          props: {
            inboundOrders: rows
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      viewLog(row) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: `/supply/purchaseInbound/logPage`,
            params: {
              model: {
                deliveryNoteId: row.deliveryNoteId
              }
            },
            opTypeOption: [
              {id: 'Inbound', text: '入库'},
            ]
          }
        });
      },
      openDetail(row, flag){
        if (flag) {
          row.items = row.productsCopy;
          row.expand = flag;
        } else {
          row.items = row.items.slice(0,3);
          row.expand = flag;
        }
        this.tableData = this.tableData.map(v => {
          if (v.deliveryNoteId === row.deliveryNoteId) {
            v.expand = row.expand
            v.items = row.items
          }
          return v
        })
        this.bakSelectedRows = this._.cloneDeep(this.selectedRows);
      }
    }
  }
</script>

<style lang="scss" scoped>
.iconfont{
  font-size: 10px;
  color: #999;
}
.iconshouqi{
  margin-left: 5px;
}
.purchaseOrder-content{
  display: inline-block;
  width: 150px;
}
.default {
  /deep/ .gj-link{
    &:hover{
      .iconfont{
        color: #1F6EEF;
      }
    }
  }
}
</style>

